// extracted by mini-css-extract-plugin
export default {"figure":"NginxCertbotMcp_figure__VbUSw","repoLink":"NginxCertbotMcp_repoLink__HmRkr"};